<template lang="pug">
  b-modal#viewResultChangesDetail(
  ref="viewResultChangesDetail"
  :title="$t('ui.combine.view_result_changes_detail')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  ok-only
  @show="reset"
  @shown="shown")
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      b-form-group(:label="$t('ui.account_id')" disabled).mb-0
        DebounceInput(
          size="sm"
          ref="account_id"
          required
          alphaNum
          type="text"
          :dirty="$v.account_id.$dirty"
          :error="$v.account_id.$error"
          v-model.trim.lazy="$v.account_id.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.account_id" :name="$t('ui.account_id')")
      b-form-group(:label="$t('ui.raw_msg')" disabled).mb-3
        b-form-textarea(v-model="raw_msg" rows="15")
      div.row
        div.col
          b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fas fa-check" :text="$t('ui.ok')" isModal=true)
</template>

<script>
import { required, minLength, maxLength, alphaNum, integer, email, helpers } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    item: {
      type: Object
    },
  },
  data() {
    return {
      account_id: "",
      raw_msg: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: {
  },
  validations: {
    account_id: {
      required
    }
  },
  methods: {
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.account_id = this.item.member_id;
      var obj = JSON.parse(this.item.raw_msg);
      this.raw_msg = JSON.stringify(obj, undefined, 4);
      // this.raw_msg = this.item.raw_msg;
    }
  }
};
</script>
